import React, { useRef, useState, useEffect } from "react";
import "./gallery.scss";

// Import images
import under1 from "../../images/under1.jpg";
import under2 from "../../images/under2.jpg";
import under3 from "../../images/under3.jpg";
import under4 from "../../images/under4.jpg";
import under5 from "../../images/under5.jpg";

const Gallery = () => {
    const images = [under1, under2, under3, under4, under5];
    const carouselRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    // Check scroll position and update arrow visibility
    const updateScrollButtons = () => {
        if (carouselRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
            setCanScrollLeft(scrollLeft > 0);
            setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
        }
    };

    const scrollLeft = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({ left: -300, behavior: "smooth" });
        }
    };

    const scrollRight = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
        }
    };

    // Add event listeners for scroll and resize
    useEffect(() => {
        const carousel = carouselRef.current;
        if (carousel) {
            updateScrollButtons(); // Initial check
            carousel.addEventListener("scroll", updateScrollButtons);
        }

        // Add window resize listener
        window.addEventListener("resize", updateScrollButtons);

        return () => {
            if (carousel) {
                carousel.removeEventListener("scroll", updateScrollButtons);
            }
            window.removeEventListener("resize", updateScrollButtons);
        };
    }, []);

    return (
        <section id="gallery" className="pb-0">
            <div className="custom-carousel-wrapper">
                {canScrollLeft && (
                    <button className="custom-carousel-control-prev" onClick={scrollLeft}>
                        <span className="material-symbols-outlined">chevron_left</span>
                    </button>
                )}
                <div className="custom-carousel" ref={carouselRef}>
                    {images.map((image, idx) => (
                        <div key={idx} className="custom-carousel-item">
                            <img src={image} alt={`Undercoating ${idx + 1}`} />
                        </div>
                    ))}
                </div>
                {canScrollRight && (
                    <button className="custom-carousel-control-next" onClick={scrollRight}>
                        <span className="material-symbols-outlined">chevron_right</span>
                    </button>
                )}
            </div>
        </section>
    );
};

export default Gallery;